import { redirect } from "@tanstack/react-router";

import { isElectron } from "../../env";
import { readLocalApi } from "../../localApi";
import {
  isSettingsSectionOfferedOnClient,
  type SettingsClientBridges,
  type SettingsSectionPath,
} from "./settingsNavigation.logic";

/** The bridges this client carries. Both are composed before the renderer runs, so read once. */
export function readSettingsClientBridges(): SettingsClientBridges {
  return {
    desktopBridgeAvailable: isElectron,
    connectBridgeAvailable: readLocalApi()?.connect !== undefined,
  };
}

/** A gated section's route guard: a client that cannot show the section lands on General. */
export function redirectUnlessOfferedOnClient(path: SettingsSectionPath): void {
  if (!isSettingsSectionOfferedOnClient(path, readSettingsClientBridges())) {
    throw redirect({ to: "/settings/general", replace: true });
  }
}
